import {
  Device,
  Statistics,
  StatisticsClassNames,
} from "@services/devices/types";

export const isEndpointStatistics = (s: Statistics) =>
  s["@class"] === StatisticsClassNames.Endpoint;
export const findEndpointStatistic = (d?: Device) =>
  d?.detailedStatuses
    ?.find((d) => d.statistics?.some(isEndpointStatistics))
    ?.statistics?.find(isEndpointStatistics);
